import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { ApiKey, UsageService } from '../../../services/usage.service';

@Component({
  selector: 'app-api-key-dialog',
  templateUrl: './api-key-dialog.component.html',
  styleUrl: './api-key-dialog.component.scss',
})
export class ApiKeyDialogComponent {
  @Input() data: any = undefined;

  form: FormGroup;

  constructor(
    protected fb: FormBuilder,
    protected dialogRef: NbDialogRef<ApiKeyDialogComponent>,
    protected usageService: UsageService
  ) {
    this.form = fb.group({
      name: this.fb.control('', Validators.required),
      // request_quota_limit: this.fb.control(''),
    });
  }

  async onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    if (this.form.value.request_quota_limit === '') {
      this.form.value.request_quota_limit = 0;
    }

    this.usageService
      .createApiKey({
        ...(this.form.value as ApiKey),
      })
      .subscribe(() => {
        this.dialogRef.close();
      });
  }

  showInputError(name: string) {
    return this.form.get(name)?.touched && this.form.get(name)?.invalid;
  }
}
